import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../../utils/firebase/firebase';

export default function PageViewTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    logPageView(`${pathname}${search}`);
  }, [pathname, search]);

  return null;
}
